import { upperFirst, camelCase } from "lodash";

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
  // Look for files in the current directory
  "@/components/base",
  // Do not look in subdirectories
  false,
  // Only include "_base-" prefixed .vue files
  /Base[\w-]+\.vue$/,
);

export default function registerBaseComponents(app) {
  // For each matching file name...
  requireComponent.keys().forEach((fileName) => {
    // Get the component config
    const componentConfig = requireComponent(fileName);
    // Get the PascalCase version of the component name
    const componentName = upperFirst(
      camelCase(
        fileName
          // Remove the "./_" from the beginning
          .replace(/^\.\/_/, "")
          // Remove the file extension from the end
          .replace(/\.\w+$/, ""),
      ),
    );
    // Globally register the component
    app.component(componentName, componentConfig.default || componentConfig);
  });
}
